export const CARDS_BLOCK_c10 = {
  "blockType": "CARDS",
  "blockDesign": "BYOCards",
  "editFormName": "DESIGN_CARD_PANEL",
  "styleProps": {
    "background-color": "#ffffff",
    "padding": "120px 20px 120px 20px",
    "background-image": "linear-gradient(to right,,)"
  },
  "headings": [
    {
      "text": "Our Leadership Team",
      "styleProps": {
        "text-align": "center",
        "color": "#333333",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-weight": "600"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "1.875rem",
        "line-height": "2.25rem"
      }
    },
    {
      "text": "Meet the visionaries behind our company:",
      "styleProps": {
        "color": "#333333",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "30px 0px 80px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 60px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 50px 0px"
      }
    }
  ],
  "cardElements": [
    {
      "type": "text",
      "id": 1746531362022,
      "elIndex": 0,
      "text": "[[name]]",
      "location": "B",
      "params": [
        {
          "value": "name",
          "label": "name"
        }
      ],
      "styleProps": {
        "margin": "0px 0px 20px 0px",
        "font-size": "3rem",
        "line-height": "1",
        "color": "",
        "font-weight": "500",
        "opacity": "1",
        "text-align": "left"
      },
      "stylePropsTab": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "1px 0px 0px 0px"
      },
      "renderHTML": true
    },
    {
      "type": "text",
      "id": 1747230478697,
      "elIndex": 1,
      "text": "[[description]]",
      "location": "B",
      "params": [
        {
          "value": "description",
          "label": "description"
        }
      ],
      "styleProps": {
        "margin": "0px 0px 0px 0px",
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      },
      "stylePropsMob": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      },
      "stylePropsTab": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      }
    },
    {
      "type": "text",
      "id": 1746529638292,
      "elIndex": 2,
      "text": "[[tags]]",
      "location": "C",
      "params": [
        {
          "value": "tags",
          "label": "tags"
        }
      ],
      "styleProps": {
        "color": "#333333",
        "font-size": "0.875rem",
        "line-height": "1.25rem",
        "font-weight": "500",
        "margin": "0px 0px 0px 0px",
        "padding": "20px 0px 0px 0px"
      },
      "stylePropsTab": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 0px 0px"
      },
      "renderHTML": false,
      "csv": true,
      "csvElementStyleProps": {
        "background-color": "#ffffff33",
        "color": "#ffffff",
        "margin": "0px 0px 4px 0px",
        "padding": "4px 10px 4px 10px",
        "border-radius": "1rem"
      }
    },
    {
      "type": "button",
      "id": 1747075505385,
      "elIndex": 3,
      "text": "View Profile",
      "location": "D",
      "params": [
        {
          "value": "status",
          "label": "status "
        }
      ],
      "styleProps": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "font-weight": "600",
        "background-color": "",
        "text-align": "center"
      },
      "btnStyleProps": {
        "border-width": "0px",
        "border-radius": "1rem",
        "background-color": "#040729",
        "padding": "14px 20px 14px 20px",
        "color": "#D5D7EC",
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 0px 0px",
        "width": "100%",
        "font-weight": "600"
      }
    },
    {
      "type": "image",
      "id": 1747240881600,
      "elIndex": 4,
      "text": "",
      "location": "A",
      "params": {
        "value": "img",
        "label": "img"
      },
      "imageContent": "crop",
      "imgStyleProps": {
        "height": "170px",
        "width": "100%",
        "border-radius": "1.5rem"
      }
    }
  ],
  "cardConfig": {
    "perRow": {
      "mobile": 1,
      "tab": 1,
      "desktop": 1
    },
    "layout": "l4",
    "cardstyleProps": {
      "padding": "2px 2px 2px 2px"
    },
    "cardstylePropsMob": {
      "padding": "2px 0px 2px 0px"
    },
    "cardstylePropsTab": {
      "padding": "2px 2px 2px 2px"
    },
    "alternate": false
  },
  "configs": {
    "dataType": "dynamic",
    "connection": {
      "spreadsheetId": "",
      "sheetName": "",
      "connectionId": "",
      "connectionTable": "",
      "timestamp": 1747243924417
    },
    "params": [],
    "filters": {
      "categories": []
    },
    "searchConfig": {
      "showSearchBar": false,
      "searchButton": {
        "styleProps": {
          "color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "background-color": "#333333",
          "border-radius": "1.5rem",
          "margin": "0px 10px 0px 10px",
          "font-weight": "bold",
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      },
      "clearButton": {
        "styleProps": {
          "background-color": "#ececec",
          "color": "#333333",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        }
      },
      "searchContainer": {
        "styleProps": {
          "background-color": "#ececec",
          "border-radius": "1.5rem",
          "padding": "10px 20px 10px 10px",
          "margin": "30px 0px 30px 0px",
          "width": "auto"
        },
        "stylePropsTab": {
          "border-radius": "9999px"
        },
        "stylePropsMob": {
          "border-radius": "1rem",
          "width": "100%"
        }
      },
      "input": {
        "styleProps": {
          "border-radius": "9999px",
          "padding": "5px 20px 5px 20px",
          "color": "#333333",
          "font-weight": "100",
          "background-color": "#ffffff",
          "width": "auto"
        },
        "stylePropsMob": {
          "margin": "0px 0px 10px 0px",
          "width": "100%"
        }
      }
    },
    "sortBy": {
      "columnName": "",
      "ascending": true
    },
    "id": "1723883803066"
  },
  "metaDataId": 1747239493580,
  "afterIndex": 8,
  "blockId": 1747239493580,
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "cardLocations": [
    {
      "name": "outer",
      "styleProps": {
        "background-image": "linear-gradient(to right,#304BF8,#162DC7)",
        "border-radius": "2.5rem",
        "padding": "20px 20px 20px 20px",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-color": "",
        "box-shadow": "",
        "width": "none",
        "margin": "0px 0px 0px 0px",
        "color": "#ffffff",
        "border-width": "0px",
        "border-color": ""
      },
      "stylePropsTab": {
        "border-radius": "1rem",
        "width": "auto",
        "padding": "20px 20px 20px 20px"
      },
      "stylePropsMob": {
        "border-radius": "0.75rem",
        "width": "auto",
        "padding": "20px 20px 20px 20px"
      }
    },
    {
      "name": 0
    },
    {
      "name": "A",
      "styleProps": {
        "background-color": "",
        "margin": "0px 0px 0px 0px",
        "border-radius": "1rem",
        "padding": "0px 10px 0px 0px",
        "box-shadow": "",
        "alignItems": "",
        "justify-content": "center",
        "flex-direction": "column",
        "display": "flex",
        "width": "25%",
        "text-align": "left",
        "background-image": "linear-gradient(to right,,)",
        "background-repeat": "no-repeat",
        "background-position": "center",
        "background-size": "cover",
        "color": ""
      },
      "innerDiv": {
        "styleProps": {
          "height": "auto",
          "width": "auto",
          "border-radius": "50%",
          "background-image": "linear-gradient(to right,,)",
          "padding": "0px 0px 0px 0px",
          "display": "",
          "flex-direction": "",
          "alignItems": "",
          "justify-content": "",
          "background-color": ""
        },
        "stylePropsTab": {
          "height": "auto"
        },
        "stylePropsMob": {
          "height": "auto"
        }
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "width": "100%"
      },
      "stylePropsTab": {
        "width": "50%"
      }
    },
    {
      "name": "B",
      "styleProps": {
        "padding": "0px 20px 0px 20px",
        "display": "",
        "flex-direction": "column",
        "justify-content": "",
        "width": "35%",
        "alignItems": "center",
        "text-align": "left",
        "box-shadow": "",
        "border-radius": "1rem",
        "background-color": "",
        "background-image": "linear-gradient(to right,,)",
        "color": "",
        "border-width": "0px",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsTab": {
        "padding": "0px 10px 0px 10px",
        "width": "50%"
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "width": "100%"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto",
          "display": "",
          "flex-direction": "",
          "alignItems": "",
          "justify-content": "",
          "padding": "0px 0px 0px 0px",
          "border-width": "0px",
          "background-color": "",
          "box-shadow": ""
        },
        "stylePropsMob": {
          "width": "auto"
        }
      }
    },
    {
      "name": "C",
      "styleProps": {
        "width": "25%",
        "display": "",
        "flex-direction": "",
        "alignItems": "",
        "justify-content": "",
        "text-align": "center",
        "padding": "0px 10px 0px 10px"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto",
          "display": "",
          "flex-direction": "",
          "alignItems": "",
          "justify-content": "",
          "background-color": "",
          "padding": "0px 0px 0px 0px"
        }
      },
      "stylePropsTab": {
        "width": "50%"
      },
      "stylePropsMob": {
        "width": "100%",
        "padding": "10px 0px 10px 0px"
      }
    },
    {
      "name": "D",
      "styleProps": {
        "width": "15%",
        "padding": "0px 10px 0px 10px"
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "width": "100%"
      },
      "stylePropsTab": {
        "width": "50%"
      }
    }
  ],
  "overlay": {
    "styleProps": {
      "background-color": "",
      "background-image": "linear-gradient(to right,,)"
    }
  },
  "containerStyleProps": {
    "max-width": "auto"
  },
  "cardLink": {
    "active": false
  }
}